"use strict";
/**
 * @fileoverview Request body type for setting active status
 * This is a common type used for both users and groups
 */
Object.defineProperty(exports, "__esModule", { value: true });
